const DEFAULT_ENABLED_SCREENINGS = [
    "screening_1",
    "screening_2",
    "screening_3_4",
    "screening_5",
    "screening_6",
    "screening_7",
    "screening_8",
    "screening_9",
    "screening_10",
    "screening_11",
    "screening_12",
    "screening_13",
    "screening_14",
    "screening_15"
];

const DEFAULT_CONFIG = {
  showScoreSummary: true,
  requirePasscodeToShowSummary: false,
  conditionalLogicActivated: false,
  enabledScreenings: DEFAULT_ENABLED_SCREENINGS
};

const PASSED_CONFIG = normalizePassedConfig(window.SMHAT_PASSED_CONFIG || {});
const SMHAT_CONFIG = {
  ...DEFAULT_CONFIG,
  ...PASSED_CONFIG,
  enabledScreenings: Array.isArray(PASSED_CONFIG.enabledScreenings) ? PASSED_CONFIG.enabledScreenings : DEFAULT_ENABLED_SCREENINGS
};
const HAS_EXPLICIT_SCREENING_CONFIG = Array.isArray(PASSED_CONFIG.enabledScreenings);

const OPTIONAL_SCREENINGS = [
  { id: "screening_10", title: "Screening 10 - ADHD" },
  { id: "screening_11", title: "Screening 11 - Bipolar disorder" },
  { id: "screening_12", title: "Screening 12 - Gambling" },
  { id: "screening_13", title: "Screening 13 - Prolonged grief" },
  { id: "screening_14", title: "Screening 14 - Obsessive-compulsive disorder" },
  { id: "screening_15", title: "Screening 15 - Psychosis risk" }
];

const SYMPTOM_OPTIONS = [
  { label: "Not at all", value: 0 },
  { label: "Several days", value: 1 },
  { label: "More than half", value: 2 },
  { label: "Nearly every day", value: 3 }
];

const ANXIETY_KEYS = ["nervous_anxious_on_edge", "uncontrollable_worry", "worrying_too_much", "trouble_relaxing", "restless", "easily_annoyed", "feeling_afraid"];
const DEPRESSION_KEYS = ["little_interest_or_pleasure", "feeling_down", "trouble_sleeping", "tired_lack_of_energy", "poor_appetite", "feeling_bad_or_failure", "trouble_concentrating", "slow_or_figety", "ending_life"];

const SYMPTOMS = [
  ["nervous_anxious_on_edge", "Feeling nervous, anxious, or on edge"],
  ["uncontrollable_worry", "Not being able to stop or control worrying"],
  ["worrying_too_much", "Worrying too much about different things"],
  ["trouble_relaxing", "Trouble relaxing"],
  ["restless", "Being so restless that it's hard to sit still"],
  ["easily_annoyed", "Becoming easily annoyed or irritable"],
  ["feeling_afraid", "Feeling afraid as if something awful might happen"],
  ["little_interest_or_pleasure", "Little interest or pleasure in doing things"],
  ["feeling_down", "Feeling down, depressed, or hopeless"],
  ["trouble_sleeping", "Trouble falling or staying asleep or sleeping too much"],
  ["tired_lack_of_energy", "Feeling tired or having little energy"],
  ["poor_appetite", "Poor appetite or overeating"],
  ["feeling_bad_or_failure", "Feeling bad about yourself or that you are a failure or have let you or your family down"],
  ["trouble_concentrating", "Trouble concentrating on things, such as reading the newspaper or watching television"],
  ["slow_or_figety", "Noticeably moving or speaking so slowly or fidgety and restless"],
  ["ending_life", "Thoughts that you would be better off dead or of hurting yourself"]
].map(([key, title]) => ({ key, title, type: "symptom", required: true }));

const symptomByKey = Object.fromEntries(SYMPTOMS.map(question => [question.key, question]));

const QUESTIONS = {
  overall_rating: selectQuestion("overall_rating", "How difficult have these symptoms made it for you to do your work, take care of things at home, or get along with other people?", ["No Symptoms", "Not difficult at all", "Somewhat difficult", "Very difficult", "Extremely difficult"]),
  cannabis_use: toggleQuestion("cannabis_use", "Have you used cannabis/marijuana-containing products (e.g. vapes, concentrates, edibles, joints, blunts, pills, oils, capsules, sprays, creams, K1, spice) or related products (synthetic cannabis) in the last 6 months?"),
  tobacco_use: toggleQuestion("tobacco_use", "Have you used any tobacco (e.g., cigarettes, cigars, pipes, snuff, snus, chew, hooka) or nicotine-containing products (e.g. electronic-cigarettes, vapes, pouches, gum, lozenges, inhaler, nasal spray) in the last 6 months?"),
  assq_actual_sleep: selectQuestion("assq_actual_sleep", "During the recent past, how many hours of actual sleep did you get at night? (This may be different than the number of hours you spent in bed.)?", ["5 to 6 hours", "6 to 7 hours", "7 to 8 hours", "8 to 9 hours", "more than 9 hours"]),
  assq_naps: selectQuestion("assq_naps", "How many naps per week do you take?", ["none", "1 to 2", "3 to 4", "5 to 7"]),
  assq_satisfied_sleep: selectQuestion("assq_satisfied_sleep", "How satisfied/dissatisfied are you with the quality of your sleep?", ["very satisfied", "somewhat satisfied", "neither satisfied nor dissatisfied", "somewhat dissatisfied", "very dissatisfied"]),
  assq_time_to_fall_asleep: selectQuestion("assq_time_to_fall_asleep", "During the recent past, how long has it usually taken you to fall asleep each night?", ["15 minutes or less", "16 to 30 minutes", "31 to 60 minutes", "longer than 60 minutes"]),
  assq_staying_asleep: selectQuestion("assq_staying_asleep", "How often do you have trouble staying asleep?", ["none", "once or twice per week", "three or four times per week", "five to seven times per week"]),
  assq_medication: selectQuestion("assq_medication", "During the recent past, how often have you taken medicine to help you sleep (prescribed or over-the-counter)?", ["none", "once or twice per week", "three or four times per week", "five to seven times per week"]),
  assq_free_wake_up: selectQuestion("assq_free_wake_up", "Considering only your own feeling best rhythm, at what time would you get up if you were entirely free to plan your day?", ["5:00 am - 6:30 am", "6:30 am - 7:45 am", "7:45 am - 9:45 am", "9:45 am - 11:00 am", "11:00 am - 12:00 pm (noon)"]),
  assq_alert: selectQuestion("assq_alert", "How alert do you feel during the first half-hour after having awakened?", ["not at all alert", "slightly alert", "fairly alert", "very alert"]),
  assq_morning: selectQuestion("assq_morning", "Do you consider yourself to be a morning type person or an evening type person?", ["definitely a morning type", "more a morning type than an evening type", "more an evening type than a morning type", "definitely an evening type"]),
  assq_free_bed: selectQuestion("assq_free_bed", "Considering your own feeling best rhythm, at what time would you go to bed if you were entirely free to plan your evening?", ["8:00 pm - 9:00 pm", "9:00 pm - 10:15 pm", "10:15 pm - 12:30 am", "12:30 am - 1:45 am", "1:45 am - 3:00 am"]),
  assq_devices: selectQuestion("assq_devices", "Over the recent past, how often do you use an electronic device (example: cell phone, computer, tablet, T.V. etc.) within 1 hour of going to bed?", ["Not at all", "1-3 times per week", "4-6 times per week", "Every day"]),
  aasq_traveling_sleep_disturbance: toggleQuestion("aasq_traveling_sleep_disturbance", "When you are travelling for your sport, do you experience sleep disturbance?"),
  aasq_traveling_performance: toggleQuestion("aasq_traveling_performance", "When you are travelling for your sport, do you experience daytime dysfunction (feeling generally unwell or having poor performance)?"),
  aasq_snore: toggleQuestion("aasq_snore", "Are you typically a loud snorer?"),
  aasq_apnea: toggleQuestion("aasq_apnea", "Have you been told that you choke, gasp, or stop breathing for periods of time during sleep?"),
  auditc1: selectQuestion("auditc1", "How often do you have a drink containing alcohol?", ["Never", "Monthly or less", "2-4 times a month", "2-3 times a week", "4 or more times a week"]),
  auditc2: selectQuestion("auditc2", "How many standard drinks containing alcohol do you have on a typical day when you drink?", ["1-2", "3-4", "5-6", "7-9", "10 or more"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  auditc3: selectQuestion("auditc3", "How often do you have six or more drinks on one occasion?", ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  cageaid2: selectQuestion("cageaid2", "How often during the last year have you found that you were not able to stop drinking once you had started?", ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  auditc4: selectQuestion("auditc4", "How often during the last year have you failed to do what was normally expected from you because of drinking?", ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  cageaid4: selectQuestion("cageaid4", "How often during the last year have you needed a first drink in the morning to get yourself going after a heavy drinking session?", ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  cageaid3: selectQuestion("cageaid3", "How often during the last year have you had a feeling of guilt or remorse after drinking?", ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  auditc5: selectQuestion("auditc5", "How often during the last year have you been unable to remember what happened the night before because you had been drinking?", ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"], { showIf: answers => answers.auditc1 && answers.auditc1 !== "Never" }),
  auditc6: selectQuestion("auditc6", "Have you or someone else been injured as a result of your drinking?", ["No", "Yes, but not in the last year", "Yes, during the last year"]),
  cageaid1: selectQuestion("cageaid1", "Has a relative or friend or a doctor or another health worker been concerned about your drinking or suggested you cut down?", ["No", "Yes, but not in the last year", "Yes, during the last year"]),
  mode_of_entry: selectQuestion("mode_of_entry", "How was the symptom checklist completed?", ["Health care provider interviewing subject", "Health care provider interviewing subject and parent/relative", "Subject self-administered", "Subject self-administered with parent/relative input"]),
  screening8_traumatic_event: toggleQuestion("screening8_traumatic_event", "Have you ever experienced this kind of an event?"),
  screening8_event_location: selectQuestion("screening8_event_location", "If yes, did the event occur inside or outside of sport?", ["Inside", "Outside", "Both"], { showIf: answers => answers.screening8_traumatic_event === 1 }),
  screening8_nightmares: toggleQuestion("screening8_nightmares", "In the past month, have you had nightmares about the event(s) or thought about the event(s) when you did not want to?", { showIf: answers => answers.screening8_traumatic_event === 1 }),
  screening8_avoidance: toggleQuestion("screening8_avoidance", "In the past month, have you tried hard not to think about the event(s) or went out of your way to avoid situations that reminded you of the event(s)?", { showIf: answers => answers.screening8_traumatic_event === 1 }),
  screening8_on_guard: toggleQuestion("screening8_on_guard", "In the past month, have you been constantly on guard, watchful, or easily startled?", { showIf: answers => answers.screening8_traumatic_event === 1 }),
  screening8_numb_detached: toggleQuestion("screening8_numb_detached", "In the past month, have you felt numb or detached from people, activities, or your surroundings?", { showIf: answers => answers.screening8_traumatic_event === 1 }),
  screening8_guilt_blame: toggleQuestion("screening8_guilt_blame", "In the past month, have you felt guilty or unable to stop blaming yourself or others for the event(s) or any problems the events may have caused?", { showIf: answers => answers.screening8_traumatic_event === 1 }),
  screening9_cut_down_drugs: toggleQuestion("screening9_cut_down_drugs", "In the last three months, have you felt you should cut down or stop using drugs?"),
  screening9_others_annoyed: toggleQuestion("screening9_others_annoyed", "In the last three months, has anyone annoyed you or gotten on your nerves by telling you to cut down or stop using drugs?"),
  screening9_guilt: toggleQuestion("screening9_guilt", "In the last three months, have you felt guilty or bad about how much you use drugs?"),
  screening9_morning_use: toggleQuestion("screening9_morning_use", "In the last three months, have you been waking up wanting to use drugs?"),
  screening9_substances: { key: "screening9_substances", title: "Please select all that apply.", type: "multiselect", required: true, exclusiveOptions: ["None"], options: ["Caffeine", "Tobacco/Nicotine", "Cannabis/Marijuana", "Synthetic Cannabis (e.g., K2, Spice)", "Prescription Stimulants (e.g., ADD, ADHD Medications)", "Prescription Opioids-Pain (e.g., oxycodone, hydrocodone)", "Other - Specify"] },
  screening9_substances_other: { key: "screening9_substances_other", title: "Specify other substance", type: "text", required: true, showIf: answers => Array.isArray(answers.screening9_substances) && answers.screening9_substances.includes("Other - Specify") }
};

addBedaqQuestions();
addOptionalQuestions();

const PAGE_DEFINITIONS = [
  { id: "screening_1_2", title: () => firstScreeningTitle(), description: "Over the last 2 weeks, how often have you been bothered by the following problems?\nPlease select the answer that best represents how you have been.", items: [{ kind: "symptoms" }, "overall_rating"] },
  { id: "screening_3_4", title: "Screening 3 and 4", description: "Answer the cannabis and nicotine/tobacco screening questions.", items: ["cannabis_use", "tobacco_use"] },
  { id: "screening_5", title: "Screening 5", description: "The following questions relate to your sleep habits. Please select the best answer which you think represents your typical sleep habits over the recent past.", items: ["assq_actual_sleep", "assq_naps", "assq_satisfied_sleep", "assq_time_to_fall_asleep", "assq_staying_asleep", "assq_medication", "assq_free_wake_up", "assq_alert", "assq_morning", "assq_free_bed", "assq_devices", "aasq_traveling_sleep_disturbance", "aasq_traveling_performance", "aasq_snore", "aasq_apnea"] },
  { id: "screening_6", title: "Screening 6", description: "On how many of the past 7 days...", items: ["bedaq1", "bedaq2", "bedaq3", "bedaq4", "bedaq5", "bedaq6", "bedaq7", "bedaq8", "bedaq9", "bedaq10", { kind: "note", text: "Over the past 7 days..." }, "bedaq11", "bedaq12"] },
  { id: "screening_7", title: "Screen 7", description: "The following questions are about alcohol use. Please respond to each question by selecting the response that represents your alcohol use.", items: ["auditc1", "auditc2", "auditc3", "cageaid2", "auditc4", "cageaid4", "cageaid3", "auditc5", "auditc6", "cageaid1"] },
  { id: "screening_8", conditional: true, title: "Screening 8", description: "Sometimes things happen to people that are unusually or especially frightening, horrible, or traumatic. For example, a serious accident or fire, a physical or sexual assault or abuse, an earthquake or flood, a war, seeing someone be killed or seriously injured, or having a loved one die through homicide or suicide.\nPlease respond to the following questions by selecting yes or no.", items: ["screening8_traumatic_event", "screening8_event_location", "screening8_nightmares", "screening8_avoidance", "screening8_on_guard", "screening8_numb_detached", "screening8_guilt_blame"] },
  { id: "screening_9", conditional: true, title: "Screening 9", description: "The following questions are about drug(s) use in the last 3 months. Please respond to each question by selecting yes or no. When thinking about drug use consider legal ones like caffeine or nicotine, illicit/illegal drugs (including cannabis even if legal in your state/country) and prescription medications used in ways other than prescribed (i.e., higher dosages; different ways of taking them, i.e., crushing/sniffing, injecting). Do NOT include alcohol in these responses.", items: ["screening9_cut_down_drugs", "screening9_others_annoyed", "screening9_guilt", "screening9_morning_use", { kind: "note", text: "In the last 3 months, which drug(s) or substance(s) listed below caused concerns or problems in your life? Concerns may include drug-related stress, depression, insomnia, financial strain, relationship conflict, heavy use/overdose, cravings, withdrawal, blackouts, flashbacks, fights, arrests, missed work, and/or medical problems like hepatitis, seizures or weight loss. Please select all that apply." }, "screening9_substances", "screening9_substances_other"] },
  { id: "mode_of_entry", title: "Checklist Completed By", description: "Select how the symptom checklist was completed.", items: ["mode_of_entry"] },
  { id: "screening_10", optional: true, title: "Screening 10", description: "Please select the answer that best describes how you have felt and conducted yourself over the past 6 months.", items: ["screening10_wrap_details", "screening10_organization", "screening10_remembering", "screening10_delay_starting", "screening10_fidget", "screening10_overactive"] },
  { id: "screening_11", optional: true, title: "Screening 11", description: "Please respond to each question by selecting yes or no.", items: [...numberedKeys("screening11_item", 13), "screening11_same_period", "screening11_problem_level", "screening11_family_history", "screening11_professional_diagnosis"] },
  { id: "screening_12", optional: true, title: "Screening 12", description: "Please select the answer that best represents how you have been feeling towards gambling in the last 12 months.", items: numberedKeys("screening12_item", 9) },
  { id: "screening_13", optional: true, title: "Screening 13", description: "Please answer the following questions about prolonged grief.", items: ["screening13_lost_significant", "screening13_months_since_death", { kind: "note", text: "For each item below, please select how you currently feel. Since the death, or as a result of the death..." }, ...numberedKeys("screening13_symptom", 10), "screening13_impairment"] },
  { id: "screening_14", optional: true, title: "Screening 14", description: "The following statements refer to experiences that many people have in their everyday lives. Please select the answer that best describes how much that experience has distressed or bothered you during the past month.", items: numberedKeys("screening14_item", 18) },
  { id: "screening_15", optional: true, title: "Screening 15", description: "Please select the answer that best represents how you are feeling. If the statement is true, select the distress level you experienced.", items: numberedKeys("screening15_item", 16) }
];

const state = {
  pageIndex: 0,
  symptoms: {},
  question_answers: {},
  didAskAboutOptionalScreenings: HAS_EXPLICIT_SCREENING_CONFIG && configuredOptionalScreeningIds().size > 0,
  selectedOptionalScreeningIds: configuredOptionalScreeningIds(),
  isSubmitting: false
};

function selectQuestion(key, title, options, overrides = {}) {
  return { key, title, type: "select", required: true, options, ...overrides };
}

function toggleQuestion(key, title, overrides = {}) {
  return { key, title, type: "toggle", required: true, ...overrides };
}

function textQuestion(key, title, overrides = {}) {
  return { key, title, type: "text", required: true, ...overrides };
}

function numberedKeys(prefix, count) {
  return Array.from({ length: count }, (_, index) => `${prefix}${index + 1}`);
}

function normalizePassedConfig(config) {
  if (!config || typeof config !== "object" || Array.isArray(config)) return {};

  const normalized = {};
  const enabledScreenings = config.enabled_screenings || config.enabledScreenings;
  if (Array.isArray(enabledScreenings)) {
    normalized.enabledScreenings = enabledScreenings.filter(value => typeof value === "string" && value.trim()).map(value => value.trim());
  }

  const showScoreSummary = config.show_score_summary ?? config.showScoreSummary;
  if (showScoreSummary !== undefined) normalized.showScoreSummary = configBoolean(showScoreSummary);

  const requirePasscodeToShowSummary = config.require_passcode_to_show_summary ?? config.requirePasscodeToShowSummary;
  if (requirePasscodeToShowSummary !== undefined) {
    normalized.requirePasscodeToShowSummary = configBoolean(requirePasscodeToShowSummary);
  }

  const conditionalLogicActivated = config.conditional_logic_activated ?? config.conditionalLogicActivated;
  if (conditionalLogicActivated !== undefined) {
    normalized.conditionalLogicActivated = configBoolean(conditionalLogicActivated);
  }

  return normalized;
}

function configBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;
  if (typeof value === "string") return !["false", "0", "no", "off", ""].includes(value.trim().toLowerCase());
  return Boolean(value);
}

function addBedaqQuestions() {
  const titles = {
    1: "Have you been deliberately trying to limit the amount of food you eat to influence your weight or shape (whether or not you have succeeded)?",
    2: "Have you gone for long periods of time (e.g., 8 or more waking hours) without eating anything at all in order to influence your weight or shape?",
    3: "Has thinking about food, eating or calories made it very difficult to concentrate on things you are interested in (such as working, following a conversation or reading)?",
    4: "Has thinking about your weight or shape made it very difficult to concentrate on things you are interested in (such as working, following a conversation or reading)?",
    5: "Have you had a definite fear that you might gain weight?",
    6: "Have you had a strong desire to lose weight?",
    7: "Have you tried to control your weight or shape by making yourself sick (vomit) or taking laxatives?",
    8: "Have you exercised in a driven or compulsive way as a means of controlling your weight, shape or body fat, or to burn off calories?",
    9: "Have you had a sense of having lost control over your eating (at the time that you were eating)?",
    10: "On how many of these days (i.e. days on which you had a sense of having lost control over your eating) did you eat what other people would regard as an unusually large amount of food in one go?",
    11: "Has your weight or shape influenced how you think about (judge) yourself as a person?",
    12: "How dissatisfied have you been with your weight or shape?"
  };

  for (let index = 1; index <= 12; index += 1) {
    const options = index <= 10 ? ["0 days", "1-2 days", "3-5 days", "6-7 days"] : ["Not at all", "Slightly", "Moderately", "Markedly"];
    QUESTIONS[`bedaq${index}`] = selectQuestion(`bedaq${index}`, titles[index], options);
  }
}

function addOptionalQuestions() {
  const adhdOptions = ["Never", "Rarely", "Sometimes", "Often", "Very often"];
  QUESTIONS.screening10_wrap_details = selectQuestion("screening10_wrap_details", "How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?", adhdOptions);
  QUESTIONS.screening10_organization = selectQuestion("screening10_organization", "How often do you have difficulty getting things in order when you have to do a task that requires organisation?", adhdOptions);
  QUESTIONS.screening10_remembering = selectQuestion("screening10_remembering", "How often do you have problems remembering appointments or obligations?", adhdOptions);
  QUESTIONS.screening10_delay_starting = selectQuestion("screening10_delay_starting", "When you have a task that requires a lot of thought, how often do you avoid or delay getting started?", adhdOptions);
  QUESTIONS.screening10_fidget = selectQuestion("screening10_fidget", "How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?", adhdOptions);
  QUESTIONS.screening10_overactive = selectQuestion("screening10_overactive", "How often do you feel overly active and compelled to do things, like you were driven by a motor?", adhdOptions);

  [
    "you felt so good or so hyper that other people thought you were not your normal self or you were so hyper that you got into trouble?",
    "you were so irritable that you shouted at people or started fights or arguments?",
    "you felt much more self-confident than usual?",
    "you got much less sleep than usual and found you did not really miss it?",
    "you were much more talkative or spoke faster than usual?",
    "thoughts raced through your head or you could not slow your mind down?",
    "you were so easily distracted by things around you that you had trouble concentrating or staying on track?",
    "you had much more energy than usual?",
    "you were much more active or did many more things than usual?",
    "you were much more social or outgoing than usual, for example, you telephoned friends in the middle of the night?",
    "you were much more interested in sex than usual?",
    "you did things that were unusual for you or that other people might have thought were excessive, foolish, or risky?",
    "spending money got you or your family in trouble?"
  ].forEach((title, index) => {
    QUESTIONS[`screening11_item${index + 1}`] = toggleQuestion(`screening11_item${index + 1}`, `Has there ever been a period of time when you were not your usual self and ${title}`);
  });
  QUESTIONS.screening11_same_period = toggleQuestion("screening11_same_period", "If you checked YES to more than one of the above, have several of these ever happened during the same period of time?");
  QUESTIONS.screening11_problem_level = selectQuestion("screening11_problem_level", "How much of a problem did any of these cause you - like being able to work; having family, money, or legal troubles; getting into arguments or fights?", ["No problem", "Minor problem", "Moderate problem", "Serious problem"]);
  QUESTIONS.screening11_family_history = toggleQuestion("screening11_family_history", "Have any of your blood relatives had manic-depressive illness or bipolar disorder?");
  QUESTIONS.screening11_professional_diagnosis = toggleQuestion("screening11_professional_diagnosis", "Has a health professional ever told you that you have manic-depressive illness or bipolar disorder?");

  [
    "Have you bet more than you could really afford to lose?",
    "Have you needed to gamble with larger amounts of money to get the same feeling of excitement?",
    "When you gambled, did you go back another day to try to win back the money you lost?",
    "Have you borrowed money or sold anything to get money to gamble?",
    "Have you felt that you might have a problem with gambling?",
    "Has gambling caused you any health problems, including stress or anxiety?",
    "Have people criticised your betting or told you that you had a gambling problem, regardless of whether or not you thought it was true?",
    "Has gambling caused any financial problems for you or your household?",
    "Have you felt guilty about the way you gamble or what happens when you gamble?"
  ].forEach((title, index) => {
    QUESTIONS[`screening12_item${index + 1}`] = selectQuestion(`screening12_item${index + 1}`, title, ["Never", "Sometimes", "Most of the time", "Almost always"]);
  });

  QUESTIONS.screening13_lost_significant = toggleQuestion("screening13_lost_significant", "Have you lost someone significant to you?");
  QUESTIONS.screening13_months_since_death = textQuestion("screening13_months_since_death", "How many months has it been since your significant other died?", { showIf: answers => answers.screening13_lost_significant === 1 });
  [
    "Do you feel yourself longing or yearning for the person who died?",
    "Do you have trouble doing the things you normally do because you are thinking so much about the person who died?",
    "Do you feel confused about your role in life or feel like you do not know who you are anymore (i.e., feeling like that a part of you has died)?",
    "Do you have trouble believing that the person who died is really gone?",
    "Do you avoid reminders that the person who died is really gone?",
    "Do you feel emotional pain (e.g., anger, bitterness, sorrow) related to the death?",
    "Do you feel that you have trouble re-engaging in life (e.g., problems engaging with friends, pursuing interests, planning for the future)?",
    "Do you feel emotionally numb or detached from others?",
    "Do you feel that life is meaningless without the person who died?",
    "Do you feel alone or lonely without the deceased?"
  ].forEach((title, index) => {
    QUESTIONS[`screening13_symptom${index + 1}`] = selectQuestion(`screening13_symptom${index + 1}`, title, ["Not at all", "Slightly", "Somewhat", "Quite a bit", "Overwhelmingly"], { showIf: answers => answers.screening13_lost_significant === 1 });
  });
  QUESTIONS.screening13_impairment = toggleQuestion("screening13_impairment", "Have the symptoms above caused significant impairment in social, occupational, or other important areas of functioning?", { showIf: answers => answers.screening13_lost_significant === 1 });

  [
    "I have saved up so many things that they get in the way.",
    "I check things more often than necessary.",
    "I get upset if objects are not arranged properly.",
    "I feel compelled to count while I am doing things.",
    "I find it difficult to touch an object when I know it has been touched by strangers or certain people.",
    "I find it difficult to control my own thoughts.",
    "I collect things I do not need.",
    "I repeatedly check doors, windows, drawers, etc.",
    "I get upset if others change the way I have arranged things.",
    "I feel I have to repeat certain numbers.",
    "I sometimes have to wash or clean myself simply because I feel contaminated.",
    "I am upset by unpleasant thoughts that come into my mind against my will.",
    "I avoid throwing things away because I am afraid I might need them later.",
    "I repeatedly check gas and water taps and light switches after turning them off.",
    "I need things to be arranged in a particular order.",
    "I feel that there are good and bad numbers.",
    "I wash my hands more often and longer than necessary.",
    "I frequently get nasty thoughts and have difficulty in getting rid of them."
  ].forEach((title, index) => {
    QUESTIONS[`screening14_item${index + 1}`] = selectQuestion(`screening14_item${index + 1}`, title, ["Not at all", "A little", "Moderately", "A lot", "Extremely"]);
  });

  [
    "I feel uninterested in the things I used to enjoy.",
    "I often seem to live through events exactly as they happened before (deja vu).",
    "I sometimes smell or taste things that other people cannot smell or taste.",
    "I often hear unusual sounds like banging, clicking, hissing, clapping or ringing in my ears.",
    "I have been confused at times whether something I experienced was real or imaginary.",
    "When I look at a person, or look at myself in a mirror, I have seen the face change right before my eyes.",
    "I get extremely anxious when meeting people for the first time.",
    "I have seen things that other people apparently cannot see.",
    "My thoughts are sometimes so strong that I can almost hear them.",
    "I sometimes see special meanings in advertisements, shop windows, or in the way things are arranged around me.",
    "Sometimes I have felt that I am not in control of my own ideas or thoughts.",
    "Sometimes I feel suddenly distracted by distant sounds that I am not normally aware of.",
    "I have heard things other people cannot hear like voices of people whispering or talking.",
    "I often feel that others have it in for me.",
    "I have had the sense that some person or force is around me, even though I could not see anyone.",
    "I feel that parts of my body have changed in some way, or that parts of my body are working differently than before."
  ].forEach((title, index) => {
    QUESTIONS[`screening15_item${index + 1}`] = selectQuestion(`screening15_item${index + 1}`, title, ["False", "True - no distress", "True - mild distress", "True - moderate distress", "True - severe distress"]);
  });
}

function screeningEnabled(id) {
  return SMHAT_CONFIG.enabledScreenings.includes(id);
}

function configuredOptionalScreeningIds() {
  if (!HAS_EXPLICIT_SCREENING_CONFIG) return new Set();
  return new Set(OPTIONAL_SCREENINGS.filter(screening => screeningEnabled(screening.id)).map(screening => screening.id));
}

function firstPageEnabled() {
  return screeningEnabled("screening_1") || screeningEnabled("screening_2") || screeningEnabled("screening_1_2");
}

function firstPageSymptomKeys() {
  const keys = [];
  if (screeningEnabled("screening_1") || screeningEnabled("screening_1_2")) keys.push(...ANXIETY_KEYS);
  if (screeningEnabled("screening_2") || screeningEnabled("screening_1_2")) keys.push(...DEPRESSION_KEYS);
  return keys;
}

function firstScreeningTitle() {
  const hasAnxiety = screeningEnabled("screening_1") || screeningEnabled("screening_1_2");
  const hasDepression = screeningEnabled("screening_2") || screeningEnabled("screening_1_2");
  if (hasAnxiety && hasDepression) return "Screening 1 (Anxiety) and 2 (Depression)";
  return hasAnxiety ? "Screening 1 (Anxiety)" : "Screening 2 (Depression)";
}

function enabled(page) {
  if (page.id === "mode_of_entry") return true;
  if (page.id === "screening_1_2") return firstPageEnabled();
  if (page.conditional && SMHAT_CONFIG.conditionalLogicActivated) return true;
  return screeningEnabled(page.id);
}

function conditionalScreeningsTriggered() {
  return screeningEightTriggered() || screeningNineTriggered();
}

function screeningEightTriggered() {
  return sumSymptoms(ANXIETY_KEYS) >= 10 || sumSymptoms(DEPRESSION_KEYS) >= 10;
}

function screeningNineTriggered() {
  return state.question_answers.cannabis_use === 1 || state.question_answers.tobacco_use === 1;
}

function optionalScreeningsAvailable() {
  if (!HAS_EXPLICIT_SCREENING_CONFIG) return OPTIONAL_SCREENINGS;
  return OPTIONAL_SCREENINGS.filter(screening => screeningEnabled(screening.id));
}

function visiblePages() {
  return PAGE_DEFINITIONS.filter(page => {
    if (!enabled(page)) return false;
    if (page.conditional && !conditionalTriggerForPage(page)) return false;
    if (page.optional && !state.selectedOptionalScreeningIds.has(page.id)) return false;
    return true;
  });
}

function conditionalTriggerForPage(page) {
  if (page.id === "screening_8") return screeningEightTriggered();
  if (page.id === "screening_9") return screeningNineTriggered();
  return conditionalScreeningsTriggered();
}

function sumSymptoms(keys) {
  return keys.reduce((sum, key) => sum + Number(state.symptoms[key] || 0), 0);
}

function visibleQuestion(question) {
  return !question.showIf || question.showIf(state.question_answers);
}

function render() {
  const pages = visiblePages();
  if (state.pageIndex >= pages.length) state.pageIndex = pages.length - 1;
  const page = pages[state.pageIndex];
  const container = document.querySelector("[data-question-container]");

  document.querySelector("[data-page-title]").textContent = typeof page.title === "function" ? page.title() : page.title;
  document.querySelector("[data-page-description]").textContent = page.description;
  document.querySelector("[data-page-count]").textContent = `${state.pageIndex + 1} of ${pages.length}`;
  document.querySelector("[data-progress-fill]").style.width = `${((state.pageIndex + 1) / pages.length) * 100}%`;
  document.querySelector("[data-back-button]").disabled = state.pageIndex === 0;
  document.querySelector("[data-next-button]").textContent = state.pageIndex + 1 === pages.length ? "Complete" : "Continue";

  container.innerHTML = "";
  page.items.forEach(item => renderItem(container, item));
}

function scrollToCurrentPageTop() {
  const shell = document.querySelector(".smhat-shell");
  if (!shell) return;

  window.requestAnimationFrame(() => {
    shell.scrollIntoView({ behavior: "auto", block: "start" });
  });
}

function renderItem(container, item) {
  if (item.kind === "symptoms") {
    firstPageSymptomKeys().map(key => symptomByKey[key]).filter(Boolean).forEach(question => container.appendChild(questionRow(question)));
    return;
  }

  if (item.kind === "note") {
    const note = document.createElement("div");
    note.className = "smhat-section-note";
    note.textContent = item.text;
    container.appendChild(note);
    return;
  }

  const question = QUESTIONS[item];
  if (question && visibleQuestion(question)) {
    container.appendChild(questionRow(question));
  }
}

function questionRow(question) {
  const row = document.createElement("div");
  row.className = "smhat-row";
  row.dataset.key = question.key;

  const title = document.createElement("div");
  title.className = "smhat-question";
  title.textContent = question.title;
  row.appendChild(title);

  const control = document.createElement("div");
  control.appendChild(inputFor(question));
  row.appendChild(control);
  return row;
}

function inputFor(question) {
  if (question.type === "symptom") return segmentedControl(question, SYMPTOM_OPTIONS, state.symptoms[question.key]);
  if (question.type === "toggle") return segmentedControl(question, [{ label: "No", value: 0 }, { label: "Yes", value: 1 }], state.question_answers[question.key]);
  if (question.type === "select") return selectControl(question);
  if (question.type === "multiselect") return multiselectControl(question);
  if (question.type === "text") return textControl(question);
}

function segmentedControl(question, options, currentValue) {
  const group = document.createElement("div");
  group.className = "smhat-segmented";

  options.forEach(option => {
    const id = `${question.key}_${String(option.value).replace(/[^a-z0-9]/gi, "_")}`;
    const input = document.createElement("input");
    input.type = "radio";
    input.name = question.key;
    input.id = id;
    input.value = option.value;
    input.checked = Number(currentValue) === option.value;
    input.addEventListener("change", () => {
      const target = question.type === "symptom" ? state.symptoms : state.question_answers;
      target[question.key] = option.value;
      clearHiddenAnswers();
      render();
    });

    const label = document.createElement("label");
    label.setAttribute("for", id);
    label.textContent = option.label;

    group.appendChild(input);
    group.appendChild(label);
  });

  return group;
}

function selectControl(question) {
  const select = document.createElement("select");
  select.className = "smhat-select";
  select.name = question.key;

  const placeholder = document.createElement("option");
  placeholder.value = "";
  placeholder.textContent = "Select response";
  select.appendChild(placeholder);

  question.options.forEach(option => {
    const element = document.createElement("option");
    element.value = option;
    element.textContent = option;
    element.selected = state.question_answers[question.key] === option;
    select.appendChild(element);
  });

  select.addEventListener("change", () => {
    if (select.value) {
      state.question_answers[question.key] = select.value;
    } else {
      delete state.question_answers[question.key];
    }
    clearHiddenAnswers();
    render();
  });

  return select;
}

function multiselectControl(question) {
  const wrapper = document.createElement("div");
  wrapper.className = "smhat-multiselect";
  const current = Array.isArray(state.question_answers[question.key]) ? state.question_answers[question.key] : [];
  const allOptions = [...question.exclusiveOptions, ...question.options];

  allOptions.forEach(option => {
    const label = document.createElement("label");
    const input = document.createElement("input");
    input.type = "checkbox";
    input.value = option;
    input.checked = current.includes(option);
    input.addEventListener("change", () => {
      let selected = Array.from(wrapper.querySelectorAll("input:checked")).map(field => field.value);
      if (question.exclusiveOptions.includes(option) && input.checked) {
        selected = [option];
      } else {
        selected = selected.filter(value => !question.exclusiveOptions.includes(value));
      }
      state.question_answers[question.key] = selected;
      clearHiddenAnswers();
      render();
    });
    label.appendChild(input);
    label.append(option);
    wrapper.appendChild(label);
  });

  return wrapper;
}

function textControl(question) {
  const input = document.createElement("input");
  input.className = "smhat-text";
  input.type = "text";
  input.name = question.key;
  input.value = state.question_answers[question.key] || "";
  input.addEventListener("input", () => {
    if (input.value.trim()) {
      state.question_answers[question.key] = input.value.trim();
    } else {
      delete state.question_answers[question.key];
    }
  });
  return input;
}

function clearHiddenAnswers() {
  Object.values(QUESTIONS).forEach(question => {
    if (!visibleQuestion(question)) {
      delete state.question_answers[question.key];
    }
  });

  if (state.question_answers.screening9_substances && !state.question_answers.screening9_substances.includes("Other - Specify")) {
    delete state.question_answers.screening9_substances_other;
  }
}

function currentPageComplete() {
  const page = visiblePages()[state.pageIndex];
  return page.items.every(item => {
    if (item.kind === "note") return true;
    if (item.kind === "symptoms") return firstPageSymptomKeys().map(key => symptomByKey[key]).every(question => answered(question));
    const question = QUESTIONS[item];
    return !question || !visibleQuestion(question) || answered(question);
  });
}

function answered(question) {
  const source = question.type === "symptom" ? state.symptoms : state.question_answers;
  const value = source[question.key];
  if (!question.required) return true;
  if (Array.isArray(value)) return value.length > 0;
  return value !== undefined && value !== null && value !== "";
}

function showPageError(message) {
  const container = document.querySelector("[data-question-container]");
  const existing = container.querySelector(".smhat-error");
  if (existing) existing.remove();

  const error = document.createElement("div");
  error.className = "smhat-error";
  error.textContent = message;
  container.prepend(error);
}

function maybeAskAboutOptionalScreenings() {
  if (state.didAskAboutOptionalScreenings || optionalScreeningsAvailable().length === 0) return false;
  state.didAskAboutOptionalScreenings = true;
  showOptionalPrompt();
  return true;
}

function showOptionalPrompt() {
  const modal = modalShell("Optional Screenings");
  const body = document.createElement("p");
  body.textContent = "Would you like to complete any optional SMHAT screenings?";
  modal.body.appendChild(body);

  const noButton = button("No", "smhat-button smhat-button-secondary", () => {
    modal.close();
    complete();
  });
  const yesButton = button("Yes", "smhat-button", () => {
    modal.close();
    showOptionalPicker();
  });
  modal.actions.append(noButton, yesButton);
}

function showOptionalPicker() {
  const modal = modalShell("Optional Screenings");
  const selected = new Set(state.selectedOptionalScreeningIds);
  const list = document.createElement("div");
  list.className = "smhat-optional-list";
  const emptySelectionMessage = document.createElement("div");
  emptySelectionMessage.className = "smhat-error";
  emptySelectionMessage.textContent = "Select at least one optional screening, or choose Skip optional.";
  emptySelectionMessage.hidden = true;

  optionalScreeningsAvailable().forEach(screening => {
    const label = document.createElement("label");
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = selected.has(screening.id);
    checkbox.addEventListener("change", () => {
      if (checkbox.checked) selected.add(screening.id);
      else selected.delete(screening.id);
      emptySelectionMessage.hidden = selected.size > 0;
    });
    label.append(checkbox, screening.title);
    list.appendChild(label);
  });
  modal.body.appendChild(emptySelectionMessage);
  modal.body.appendChild(list);

  modal.actions.append(
    button("Skip optional", "smhat-button smhat-button-secondary", () => {
      state.selectedOptionalScreeningIds = new Set();
      modal.close();
      complete();
    }),
    button("Continue", "smhat-button", () => {
      if (selected.size === 0) {
        emptySelectionMessage.hidden = false;
        return;
      }

      state.selectedOptionalScreeningIds = selected;
      modal.close();
      const pages = visiblePages();
      if (state.pageIndex + 1 < pages.length) {
        state.pageIndex += 1;
        render();
        scrollToCurrentPageTop();
      } else {
        complete();
      }
    })
  );
}

function modalShell(title) {
  const backdrop = document.createElement("div");
  backdrop.className = "smhat-modal-backdrop";
  const dialog = document.createElement("div");
  dialog.className = "smhat-modal";
  dialog.setAttribute("role", "dialog");
  dialog.setAttribute("aria-modal", "true");
  const heading = document.createElement("h2");
  heading.textContent = title;
  const body = document.createElement("div");
  body.className = "smhat-modal-body";
  const actions = document.createElement("div");
  actions.className = "smhat-modal-actions";
  dialog.append(heading, body, actions);
  backdrop.appendChild(dialog);
  document.body.appendChild(backdrop);
  return { body, actions, close: () => backdrop.remove() };
}

function button(text, className, onClick) {
  const element = document.createElement("button");
  element.type = "button";
  element.className = className;
  element.textContent = text;
  element.addEventListener("click", onClick);
  return element;
}

function payload() {
  return {
    symptoms: { ...state.symptoms },
    question_answers: { ...state.question_answers }
  };
}

function submitPayload() {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;
  const submissionUrl = window.SMHAT_SUBMISSION_URL || "/submissions";
  return fetch(submissionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken
    },
    credentials: "same-origin",
    body: JSON.stringify({ assessment: payload() })
  });
}

function complete() {
  if (state.isSubmitting) return;
  state.isSubmitting = true;
  const output = document.querySelector("[data-output-panel]");
  const completionMessage = document.querySelector("[data-completion-message]");
  const shell = document.querySelector(".smhat-shell");
  submitPayload()
    .then(response => {
      if (!response.ok) throw new Error("submit failed");
      return response.json().catch(() => ({}));
    })
    .then(responseBody => {
      completionMessage.textContent = responseBody.message || "Your mental health assessment has been submitted. You may close this tab.";
      shell.hidden = true;
      output.hidden = false;
      output.scrollIntoView({ behavior: "smooth", block: "start" });
    })
    .catch(() => {
      state.isSubmitting = false;
      showPageError("We could not submit this SMHAT assessment. Please try again.");
    });
}

function renderScoreSummary() {
  const panel = document.querySelector("[data-score-panel]");
  const table = document.querySelector("[data-score-table]");
  if (!SMHAT_CONFIG.showScoreSummary) {
    panel.hidden = true;
    return;
  }

  const rows = scoreRows();
  table.innerHTML = "";
  rows.forEach(row => {
    const item = document.createElement("div");
    item.className = "smhat-score-row";
    const title = document.createElement("div");
    title.className = "smhat-score-title";
    title.textContent = `${row.title}: ${row.total}`;
    const status = document.createElement("div");
    status.className = row.atOrAbove ? "smhat-score-status is-at-or-above" : "smhat-score-status is-under";
    status.textContent = row.atOrAbove ? `At or above threshold ${row.atOrAboveText}` : `Under threshold ${row.underText}`;
    item.append(title, status);
    table.appendChild(item);
  });
  panel.hidden = rows.length === 0;
}

function scoreRows() {
  const rows = [];
  addRowIfAnswered(rows, ANXIETY_KEYS, state.symptoms, "Anxiety (screening 1)", sumSymptoms(ANXIETY_KEYS), "0-9", ">=10", 10);
  addRowIfAnswered(rows, DEPRESSION_KEYS, state.symptoms, "Depression (screening 2)", sumSymptoms(DEPRESSION_KEYS), "0-9", ">=10", 10);
  if (hasAny(DEPRESSION_KEYS, state.symptoms)) addScoreRow(rows, "Depression item 9 (screening 2)", Number(state.symptoms.ending_life || 0), "0", ">=1", 1);
  addRowIfAnswered(rows, ["cannabis_use"], state.question_answers, "Cannabis use (screening 3)", Number(state.question_answers.cannabis_use || 0), "0", "1", 1);
  addRowIfAnswered(rows, ["tobacco_use"], state.question_answers, "Nicotine/Tobacco use (screening 4)", Number(state.question_answers.tobacco_use || 0), "0", "1", 1);
  addRowIfAnswered(rows, ASSQ_KEYS, state.question_answers, "Sleep disturbance (screening 5)", sumAnswers(ASSQ_KEYS), "0-7", ">=8", 8);
  addRowIfAnswered(rows, numberedKeys("bedaq", 12), state.question_answers, "Disordered eating (screening 6)", sumAnswers(numberedKeys("bedaq", 12)), "0-14", ">=15", 15);
  addRowIfAnswered(rows, ALCOHOL_KEYS, state.question_answers, "Alcohol misuse (screening 7)", sumAnswers(ALCOHOL_KEYS), "0-7", ">=8", 8);
  addRowIfAnswered(rows, SCREENING8_SCORE_KEYS, state.question_answers, "Traumatic stress (screening 8)", sumAnswers(SCREENING8_SCORE_KEYS), "0-2", ">=3", 3);
  addRowIfAnswered(rows, SCREENING9_SCORE_KEYS, state.question_answers, "Drug/substance use (screening 9)", sumAnswers(SCREENING9_SCORE_KEYS), "0-1", ">=2", 2);
  addRowIfAnswered(rows, SCREENING10_KEYS, state.question_answers, "ADHD (screening 10)", sumAnswers(SCREENING10_KEYS), "0-3", ">=4", 4);
  if (hasAny(SCREENING11_KEYS, state.question_answers)) {
    const total = sumAnswers(SCREENING11_ITEM_KEYS);
    const item2 = Number(state.question_answers.screening11_same_period || 0);
    const item3 = scoreAnswer("screening11_problem_level", state.question_answers.screening11_problem_level);
    rows.push({ title: "Bipolar disorder (screening 11)", total, underText: "criteria not met", atOrAboveText: `>=7, item 2 = ${item2}, item 3 = ${item3}`, atOrAbove: total >= 7 && item2 === 1 && item3 === 1 });
  }
  addRowIfAnswered(rows, numberedKeys("screening12_item", 9), state.question_answers, "Gambling (screening 12)", sumAnswers(numberedKeys("screening12_item", 9)), "0-2", ">=3", 3);
  addRowIfAnswered(rows, numberedKeys("screening13_symptom", 10), state.question_answers, "Prolonged grief (screening 13)", sumAnswers(numberedKeys("screening13_symptom", 10)), "0-29", ">=30", 30);
  addRowIfAnswered(rows, numberedKeys("screening14_item", 18), state.question_answers, "Obsessive-compulsive disorder (screening 14)", sumAnswers(numberedKeys("screening14_item", 18)), "0-20", ">=21", 21);
  addRowIfAnswered(rows, numberedKeys("screening15_item", 16), state.question_answers, "Psychosis risk (screening 15)", sumAnswers(numberedKeys("screening15_item", 16)), "0-5", ">=6", 6);
  return rows;
}

const ASSQ_KEYS = ["assq_actual_sleep", "assq_naps", "assq_satisfied_sleep", "assq_time_to_fall_asleep", "assq_staying_asleep", "assq_medication", "assq_free_wake_up", "assq_alert", "assq_morning", "assq_free_bed", "assq_devices", "aasq_traveling_sleep_disturbance", "aasq_traveling_performance", "aasq_snore", "aasq_apnea"];
const ALCOHOL_KEYS = ["auditc1", "auditc2", "auditc3", "cageaid2", "auditc4", "cageaid4", "cageaid3", "auditc5", "auditc6", "cageaid1"];
const SCREENING8_SCORE_KEYS = ["screening8_traumatic_event", "screening8_nightmares", "screening8_avoidance", "screening8_on_guard", "screening8_numb_detached", "screening8_guilt_blame"];
const SCREENING9_SCORE_KEYS = ["screening9_cut_down_drugs", "screening9_others_annoyed", "screening9_guilt", "screening9_morning_use"];
const SCREENING10_KEYS = ["screening10_wrap_details", "screening10_organization", "screening10_remembering", "screening10_delay_starting", "screening10_fidget", "screening10_overactive"];
const SCREENING11_ITEM_KEYS = numberedKeys("screening11_item", 13);
const SCREENING11_KEYS = [...SCREENING11_ITEM_KEYS, "screening11_same_period", "screening11_problem_level", "screening11_family_history", "screening11_professional_diagnosis"];

function addRowIfAnswered(rows, keys, source, title, total, underText, atOrAboveText, threshold) {
  if (hasAny(keys, source)) addScoreRow(rows, title, total, underText, atOrAboveText, threshold);
}

function addScoreRow(rows, title, total, underText, atOrAboveText, threshold) {
  rows.push({ title, total, underText, atOrAboveText, atOrAbove: total >= threshold });
}

function hasAny(keys, source) {
  return keys.some(key => source[key] !== undefined && source[key] !== null && source[key] !== "");
}

function sumAnswers(keys) {
  return keys.reduce((sum, key) => sum + scoreAnswer(key, state.question_answers[key]), 0);
}

function scoreAnswer(key, answer) {
  if (answer === undefined || answer === null) return 0;
  if (typeof answer === "number") return answer;
  const map = SCORE_MAPS[key];
  return map ? Number(map[answer] || 0) : 0;
}

const fourOptionScoreMap = { "0 days": 0, "1-2 days": 1, "3-5 days": 2, "6-7 days": 3 };
const SCORE_MAPS = {
  assq_actual_sleep: { "5 to 6 hours": 0, "6 to 7 hours": 1, "7 to 8 hours": 2, "8 to 9 hours": 3, "more than 9 hours": 4 },
  assq_naps: { none: 0, "1 to 2": 1, "3 to 4": 2, "5 to 7": 3 },
  assq_satisfied_sleep: { "very satisfied": 0, "somewhat satisfied": 1, "neither satisfied nor dissatisfied": 2, "somewhat dissatisfied": 3, "very dissatisfied": 4 },
  assq_time_to_fall_asleep: { "15 minutes or less": 0, "16 to 30 minutes": 1, "31 to 60 minutes": 2, "longer than 60 minutes": 3 },
  assq_staying_asleep: { none: 0, "once or twice per week": 1, "three or four times per week": 2, "five to seven times per week": 3 },
  assq_medication: { none: 0, "once or twice per week": 1, "three or four times per week": 2, "five to seven times per week": 3 },
  assq_free_wake_up: { "5:00 am - 6:30 am": 0, "6:30 am - 7:45 am": 1, "7:45 am - 9:45 am": 2, "9:45 am - 11:00 am": 3, "11:00 am - 12:00 pm (noon)": 4 },
  assq_alert: { "not at all alert": 0, "slightly alert": 1, "fairly alert": 2, "very alert": 3 },
  assq_morning: { "definitely a morning type": 0, "more a morning type than an evening type": 1, "more an evening type than a morning type": 2, "definitely an evening type": 3 },
  assq_free_bed: { "8:00 pm - 9:00 pm": 0, "9:00 pm - 10:15 pm": 1, "10:15 pm - 12:30 am": 2, "12:30 am - 1:45 am": 3, "1:45 am - 3:00 am": 4 },
  assq_devices: { "Not at all": 0, "1-3 times per week": 1, "4-6 times per week": 2, "Every day": 3 },
  auditc1: { Never: 0, "Monthly or less": 1, "2-4 times a month": 2, "2-3 times a week": 3, "4 or more times a week": 4 },
  auditc2: { "1-2": 0, "3-4": 1, "5-6": 2, "7-9": 3, "10 or more": 4 },
  auditc3: { Never: 0, "Less than monthly": 1, Monthly: 2, Weekly: 3, "Daily or almost daily": 4 },
  cageaid2: { Never: 0, "Less than monthly": 1, Monthly: 2, Weekly: 3, "Daily or almost daily": 4 },
  auditc4: { Never: 0, "Less than monthly": 1, Monthly: 2, Weekly: 3, "Daily or almost daily": 4 },
  cageaid4: { Never: 0, "Less than monthly": 1, Monthly: 2, Weekly: 3, "Daily or almost daily": 4 },
  cageaid3: { Never: 0, "Less than monthly": 1, Monthly: 2, Weekly: 3, "Daily or almost daily": 4 },
  auditc5: { Never: 0, "Less than monthly": 1, Monthly: 2, Weekly: 3, "Daily or almost daily": 4 },
  auditc6: { No: 0, "Yes, but not in the last year": 2, "Yes, during the last year": 4 },
  cageaid1: { No: 0, "Yes, but not in the last year": 2, "Yes, during the last year": 4 },
  bedaq11: { "Not at all": 0, Slightly: 1, Moderately: 2, Markedly: 3 },
  bedaq12: { "Not at all": 0, Slightly: 1, Moderately: 2, Markedly: 3 },
  screening10_wrap_details: { Never: 0, Rarely: 0, Sometimes: 1, Often: 1, "Very often": 1 },
  screening10_organization: { Never: 0, Rarely: 0, Sometimes: 1, Often: 1, "Very often": 1 },
  screening10_remembering: { Never: 0, Rarely: 0, Sometimes: 1, Often: 1, "Very often": 1 },
  screening10_delay_starting: { Never: 0, Rarely: 0, Sometimes: 0, Often: 1, "Very often": 1 },
  screening10_fidget: { Never: 0, Rarely: 0, Sometimes: 0, Often: 1, "Very often": 1 },
  screening10_overactive: { Never: 0, Rarely: 0, Sometimes: 0, Often: 1, "Very often": 1 },
  screening11_problem_level: { "No problem": 0, "Minor problem": 0, "Moderate problem": 1, "Serious problem": 1 }
};
numberedKeys("bedaq", 10).forEach(key => { SCORE_MAPS[key] = fourOptionScoreMap; });
numberedKeys("screening12_item", 9).forEach(key => { SCORE_MAPS[key] = { Never: 0, Sometimes: 1, "Most of the time": 2, "Almost always": 3 }; });
numberedKeys("screening13_symptom", 10).forEach(key => { SCORE_MAPS[key] = { "Not at all": 1, Slightly: 2, Somewhat: 3, "Quite a bit": 4, Overwhelmingly: 5 }; });
numberedKeys("screening14_item", 18).forEach(key => { SCORE_MAPS[key] = { "Not at all": 0, "A little": 1, Moderately: 2, "A lot": 3, Extremely: 4 }; });
numberedKeys("screening15_item", 16).forEach(key => { SCORE_MAPS[key] = { False: 0, "True - no distress": 0, "True - mild distress": 1, "True - moderate distress": 2, "True - severe distress": 3 }; });

function initializeSmhatWeb() {
  const form = document.querySelector("[data-smhat-form]");
  if (!form) return;
  if (form.dataset.smhatInitialized === "true") return;
  form.dataset.smhatInitialized = "true";

  form.addEventListener("submit", event => {
    event.preventDefault();
    if (!currentPageComplete()) {
      showPageError("Please answer all visible required questions before continuing.");
      return;
    }

    const pages = visiblePages();
    if (state.pageIndex + 1 < pages.length) {
      state.pageIndex += 1;
      render();
      scrollToCurrentPageTop();
    } else if (!maybeAskAboutOptionalScreenings()) {
      complete();
    }
  });

  document.querySelector("[data-back-button]").addEventListener("click", () => {
    if (state.pageIndex > 0) {
      state.pageIndex -= 1;
      render();
      scrollToCurrentPageTop();
    }
  });

  render();
}

document.addEventListener("DOMContentLoaded", initializeSmhatWeb);
document.addEventListener("turbo:load", initializeSmhatWeb);
